import React, {Component} from 'react'

class BoxElementItem extends Component {

  render(){

    var elmValue;

    if ( this.props.elmValue == '' ) {
      elmValue = '';
    } else {
      elmValue = this.props.elmValue;
    }

    return(
      <div className="sppb-box-element-item">
        <input
          type="text"
          className="sp-pagebuilder-form-control sp-pagebuilder-addon-input"
          autoComplete="off"
          placeholder={ this.props.direction }
          data-direction={ this.props.direction }
          data-device={ this.props.device }
          onChange={ this.props.itemChangeHandle }
          value={ elmValue }
        />
      </div>
    )
  }
}

export default BoxElementItem;



// WEBPACK FOOTER //
// ./src/helpers/form/types/BoxElementItem.js